import { DeskAreaType } from "types";
import { IConfig } from "./types/interfaces";

export const FLOOR_PLAN_STORE_NAME = "floorPlan";

export const config: IConfig = {
  deskTextYMod: 0,
  svgHeight: 700,
  svgWidth: 1400,
  pointRadius: 4,
  deskRadius: 10,
  maxDeskRadius: 20,
  minDeskRadius: 2,
  lineStrokeWidth: 2,
};

export const textHeightFontSizeMagicVar = 1.429;

export const zoneTypeColorMap: { [key: string]: string } = {
  [DeskAreaType.FlexDesk]: "var(--borders-floor-map)",
  [DeskAreaType.MeetingRoom]: "var(--borders-floor-map)", // border of rooms is calculated later based on availability
  [DeskAreaType.Parking]: "var(--borders-floor-map)",
  [DeskAreaType.Other]: "var(--resources-others)",
};

export const fillColorAnonymous = "var(--avatars-anonymous)";
export const fillColorInactive = "var(--floorplan-editor-inactive-desk)";
export const fillColorActive = "var(--floorplan-editor-active-desk)";
export const fillColorRed = "var(--floorplan-busy)";
export const fillColorWhite = "var(--text-on-colored-backgrounds)";
export const fillColorGreen = "var(--floorplan-available)";
export const fillColorSelected = "var(--floorplan-selected-desk-area)";
export const fillColorClosed = "var(--containers-dark-primary)";
export const strokeColorClosed = "var(--borders-darker)";
export const textColorClosed = "var(--text-on-floor-plan-closed-area)";

export const resourceItemContainerClass = "resource-item-container";
/** Container for restriction/favorite icons */
export const resourceIconContainerClass = "resource-icon-container";
/** Icon for restriction/favorite */
export const resourceIconClass = "resource-icon";

export const DEFAULT_FLOOR_PLAN_MAP_ITEM_ID = "0";

/**
 * Position value used to place elements far off-screen in the map editor (e.g., when not yet positioned).
 */
export const OFFSCREEN_POSITION = -10_000;

export const TRANSITION_OPACITY = "opacity 0.2s ease";
